import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

interface ResponsiveDialogProps {
    title: string
    content: string
    opened: boolean
    onYesClicked: () => void
    onNoClicked: () => void
}

export const ResponsiveDialog = (props: ResponsiveDialogProps): JSX.Element => {
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

    const { title, content, opened, onYesClicked, onNoClicked } = props

    return <Dialog fullScreen={fullScreen} open={opened} onClose={onNoClicked}>
        <DialogTitle> {title} </DialogTitle>
        <DialogContent>
            <DialogContentText> {content} </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button autoFocus onClick={onYesClicked} color='primary'>
                Yes
            </Button>
            <Button onClick={onNoClicked} color='primary' autoFocus>
                No
            </Button>
        </DialogActions>
    </Dialog>
}
